{
  "name": "wrapos-estimator",
  "private": true,
  "version": "0.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "lint": "eslint .",
    "preview": "vite preview"
  },
  "dependencies": {
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@sentry/react": "^10.48.0",
    "@sentry/vite-plugin": "^5.2.0",
    "@supabase/supabase-js": "^2.101.1",
    "canvas-confetti": "^1.9.4",
    "html2canvas": "^1.4.1",
    "react": "^19.2.4",
    "react-dom": "^19.2.4",
    "react-is": "^19.2.5",
    "recharts": "^3.8.1",
    "vite-plugin-pwa": "^1.2.0",
    "workbox-window": "^7.4.0"
  },
  "devDependencies": {
    "@eslint/js": "^9.39.4",
    "@tailwindcss/vite": "^4.3.0",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.2",
    "eslint": "^9.39.4",
    "eslint-plugin-react-hooks": "^7.0.1",
    "eslint-plugin-react-refresh": "^0.5.2",
    "globals": "^17.4.0",
    "tailwindcss": "^4.2.2",
    "vite": "^8.0.16"
  }
}
